// CRITICAL: setNonce MUST be imported first, before any FluentUI code
import "./setNonce"; // Configure CSP nonce for FluentUI dynamic styles
import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "intersection-observer";
import "./app.scss";
import { Routes } from "./Routes";
import { initializeIcons } from "@fluentui/font-icons-mdl2";

initializeIcons();

function bootstrapApp(): Promise<any> {
    //  Add any initialization steps that may return promise.
    return Promise.resolve();
}

bootstrapApp().then(() => {
    ReactDOM.render(
        <>
            <Routes />
        </>,
        document.getElementById("app-host")
    );
});
